module.exports = __webpack_public_path__ + "static/media/Bronzong_gaussian2.8dcf1699.png";